<script>
import getAgeFromDate from '@utils/age-from-date'

export default {
  props: {
    player: {
      type: Object,
      default: () => false,
    },
  },
  methods: {
    tableRowClass(key) {
      let classes = ''
      if (key === 'position') {
        classes += this.$style.posClass
      }
      if (key === 'club') {
        classes += this.$style.clubClass
      }
      if (key === 'contract') {
        classes += this.$style.contractClass
      }
      return classes
    },
    getPlayerTableData(player) {
      return {
        age: {
          label: this.$t('playerAge'),
          value: getAgeFromDate(player.birth_date),
        },
        country: {
          label: this.$t('playerCountry'),
          value: player.country,
        },
        club: {
          label: this.$t('playerClub'),
          value: player.team.name,
        },
        position: {
          label: this.$t('playerPosition'),
          value: player.position,
        },
        foot: {
          label: this.$t('playerFoot'),
          value: this.$t(player.foot_name),
        },
        contract: {
          label: this.$t('playerContract'),
          value: player.contract_expires,
        },
      }
    },
  },
}
</script>

<template>
  <v-hover v-slot="{ hover }">
    <v-card
      v-if="player"
      :link="true"
      :to="{ name: 'player-profile', params: { playerId: player.id } }"
      :elevation="hover ? 12 : 2"
      :class="[{ 'on-hover': hover }, $style.topPickCard]"
      tag="article"
    >
      <header :class="[$style.cardHeader, 'pb-0']">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <h4
              :class="$style.playerIndex"
              title="wallabies Index"
              v-bind="attrs"
              v-on="on"
              >{{ player.performance_mean_season }}</h4
            >
          </template>
          <span>{{ $t('player_index') }}</span>
        </v-tooltip>
        <img
          :src="player.thumb"
          :class="$style.playerThumb"
          alt="Player Profile"
        />
      </header>
      <v-card-title :class="$style.title" v-text="player.name"></v-card-title>
      <v-simple-table dense class="mb-4">
        <tbody>
          <tr
            v-for="(item, key) in getPlayerTableData(player)"
            :key="item.name"
            :class="tableRowClass(key)"
          >
            <td :class="$style.td">{{ item.label }}</td>
            <td :class="$style.td">{{ item.value }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>
  </v-hover>
</template>

<style lang="scss" module>
@import '@design';

.playerThumb {
  justify-content: center;
  width: 50px;
  height: 50px;

  @media screen and (min-width: $screen-md) {
    width: 70px;
    height: 70px;
  }
}

.cardHeader {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  padding: 0.5rem 0;
}

.title {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.playerIndex {
  @extend %typography-large;

  color: $color-accent !important;

  @media screen and (min-width: $screen-md) {
    position: absolute;
    bottom: 0;
    left: 15px;
  }
}

.topPickCard {
  height: 100%;
  min-height: 21rem;
  border-bottom: 4px solid #2996f3 !important;
}

.clubClass {
  height: 45px;
}

.posClass {
  height: 70px;
}

.contractClass {
  height: 45px;
}

.td {
  height: 24px !important;
  border: 0 !important;
}
</style>
